import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-success",
  templateUrl: "./success.component.html",
  styleUrls: ["./success.component.scss"],
})
export class SuccessComponent implements OnInit {
  urlParams = new URLSearchParams(window.location.search);
  creatorName = this.urlParams.get("creatorName");
  tier = this.urlParams.get("tier");
  planName = this.urlParams.get("plan");
  isUpgrade = this.urlParams.get("upgrade") === "true";

  constructor() {
    console.log(this.tier, this.creatorName);
  }

  ngOnInit(): void {}
}
